/**
 * Guest ("no ticket") mode helpers.
 *
 * Anyone can walk into the theatre and look around, but every action that
 * writes data, costs quota, or belongs to a person needs a seat. Instead of
 * sprinkling `toast("Sign in required")` calls everywhere, all of those paths
 * funnel through `requestTicket()`, which raises a single global prompt
 * (see `SeatPrompt`). One place to change the copy, one place to change the UX.
 */

export const TICKET_REQUIRED_EVENT = "swiftix:ticket-required";

export interface TicketRequest {
  /** What the visitor tried to do, phrased as a noun: "save titles". */
  action?: string;
}

export const requestTicket = (action?: string) => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent<TicketRequest>(TICKET_REQUIRED_EVENT, { detail: { action } })
  );
};
